/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Load collection elements dynamically (after ajax change)
const loadCollection = async () => {
    const productList = document.querySelector('.collection .product-list')

    if (productList) {
        productList.style.opacity = '.2'
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })

    const response = await fetch(window.location.href)
    const data = await response.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('.collection')
        ?.replaceWith(newDocument.querySelector('.collection'))

    document.querySelectorAll('#offcanvas-filters .collapse-inner').forEach((collapse) => {
        const collapseId = collapse.closest('.collapse').getAttribute('id')
        collapse.replaceWith(newDocument.querySelector(`#offcanvas-filters #${collapseId} .collapse-inner`))
    })

    document.querySelector('#offcanvas-filters .offcanvas-footer')
        ?.replaceWith(newDocument.querySelector('#offcanvas-filters .offcanvas-footer'))

    document.querySelector('#offcanvas-filters .btn-filters-clear-all')
        ?.replaceWith(newDocument.querySelector('#offcanvas-filters .btn-filters-clear-all'))

    document.querySelector('#offcanvas-filters [name="sort_by"]')
        ?.replaceWith(newDocument.querySelector('#offcanvas-filters [name="sort_by"]'))

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Handle collection filters change events
window.onChangeCollectionFilter = async (input, event) => {
    const form = input.closest('form')
    const params = new URLSearchParams(new FormData(form))
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)

    await loadCollection()
}

// Handle collection price filters change
const initCollectionFiltersPriceChange = () => {
    document.querySelectorAll('.filter-price-group input').forEach(input => {
        input.addEventListener('input', window.debounce(async (event) => {
            const form = input.closest('form')
            const params = new URLSearchParams(new FormData(form))
            const url = `${window.location.pathname}?${params.toString()}`
            window.history.replaceState({}, '', url)

            await loadCollection()
        }, 750))
    })
}
initCollectionFiltersPriceChange()
window.addEventListener('updated.ecomify.collection', initCollectionFiltersPriceChange)

// 'View more' within collection filters
window.onClickFiltersViewMore = (btn, event) => {
    btn.closest('.collapse').querySelectorAll('.form-check').forEach((elem) => {
        elem.removeAttribute('hidden')
    })

    btn.remove()
}

// 'Clear all' within collection filters
window.onClickClearAllFilters = async (btn, event) => {
    const form = btn.closest('form')
    const params = new URLSearchParams()
    params.set('sort_by', form.querySelector('[name="sort_by"]').value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)

    await loadCollection()
}

// Sort-by select change event
window.onChangeCollectionSortBy = (value) => {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)

    loadCollection()
}

// Inifinite Pagination - on click "Load more" button
window.onClickCollectionLoadMore = async (btn, event) => {
    event.preventDefault()

    btn.style.width = `${btn.offsetWidth + 2}px`
    btn.style.height = `${btn.offsetHeight + 2}px`

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    window.history.replaceState({}, '', btn.dataset.nextUrl)

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('.collection .product-list')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.collection .product-list').innerHTML)

    document.querySelector('#collection-pagination')
        .replaceWith(newDocument.querySelector('#collection-pagination'))

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Inifinite Pagination - on click "Load previous" button
window.onClickCollectionLoadPrevious = async (btn, event) => {
    event.preventDefault()

    btn.style.width = `${btn.offsetWidth + 2}px`
    btn.style.height = `${btn.offsetHeight + 2}px`

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    window.history.replaceState({}, '', btn.dataset.previousUrl)

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('.collection .product-list')
        .insertAdjacentHTML('afterbegin', newDocument.querySelector('.collection .product-list').innerHTML)

    document.querySelector('#btn-load-previous')
        ?.replaceWith(newDocument.querySelector('#btn-load-previous'))

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Infinite Pagination - automatically load products on scroll
const initPaginationObserver = () => {
    const pagination = document.querySelector('#collection-pagination')

    if (!pagination) return

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const btn = pagination.querySelector('.btn-load-more')
                if (btn) btn.click()
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' })

    observer.observe(pagination)
}
initPaginationObserver()
window.addEventListener('updated.ecomify.collection', initPaginationObserver)

// Fixed utilities bar on Scroll
const fixedUtilitiesBarOnScroll = () => {
    const utilities = document.querySelector('#collection-utilities')

    if (!utilities) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    // const top = utilities.getBoundingClientRect().top
    const top = 700

    document.addEventListener('scroll', window.throttle(() => {
        if (window.scrollY > top) {
            utilities.classList.add('sticky-top')
            utilities.style.top = `${navbarHeight + announcementBarHeight}px`
            setTimeout(() => {
                utilities.classList.add('show')
            }, 200)
        } else {
            utilities.classList.remove('show')
            setTimeout(() => {
                utilities.classList.remove('sticky-top')
                utilities.style.top = '0'
            }, 200)
        }
    }, 200))

    setInterval(() => {
        if (window.scrollY < 50) {
            utilities.classList.remove('sticky-top')
            utilities.style.top = '0'
        }
    }, 1000)
}
fixedUtilitiesBarOnScroll()
window.addEventListener('updated.ecomify.collection', () => setTimeout(() => {
    fixedUtilitiesBarOnScroll()
}, 1000))

// 'Scroll top' button visibility
const handleScrollTopButton = () => {
    const btn = document.querySelector('#btn-collection-scroll-top')
    const productList = document.querySelector('.collection .product-list')

    if (!btn || !productList) return

    const top = productList.getBoundingClientRect().top

    document.addEventListener('scroll', window.throttle(() => {
        if (window.scrollY > top) {
            btn.classList.add('btn-show')
        } else {
            btn.classList.remove('btn-show')
        }
    }, 200))
}
handleScrollTopButton()
window.addEventListener('updated.ecomify.collection', handleScrollTopButton)

// Color swatches in product list items
window.l4vShouldUseSteppedSwatches = (swatchesList) => {
    if (!swatchesList) return false
    const isMobile = window.matchMedia('(max-width: 767.98px)').matches
    if (isMobile) return true

    const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 991.98px)').matches
    if (!isTablet) return false

    return Boolean(
      swatchesList.closest('.collection .product-item') ||
      swatchesList.closest('.template-collection .product-item') ||
      swatchesList.closest('.search .product-item') ||
      swatchesList.closest('.recommended-products .product-item') ||
      swatchesList.closest('.featured-products .product-item') ||
      swatchesList.closest('[id*="featured_products"] .product-item')
    )
}

window.showAllSwatchesWithinProductItem = (btn, event) => {
    if (event) event.preventDefault()
    const swatchesList = btn.closest('.color-swatches')
    if (!swatchesList) return

    const useSteppedPaging = window.l4vShouldUseSteppedSwatches(swatchesList)
    const baseItems = [...swatchesList.querySelectorAll('.swatch-item--base')]
    const extraItems = [...swatchesList.querySelectorAll('.swatch-item--extra')]
    const toggleItem = btn.closest('.swatch-item--toggle')
    const totalMoreCount = extraItems.length

    const showItems = (items) => {
        items.forEach((elem) => {
            elem.hidden = false
            elem.style.display = ''
        })
    }
    const hideItems = (items) => {
        items.forEach((elem) => {
            elem.hidden = true
            elem.style.display = 'none'
        })
    }

    if (useSteppedPaging) {
        const step = 4
        const allItems = [...swatchesList.querySelectorAll(':scope > li:not(.swatch-item--toggle)')]
        const totalCount = allItems.length
        const lastStart = Math.max(0, (Math.ceil(totalCount / step) - 1) * step)
        let currentStart = parseInt(btn.getAttribute('data-page-start') || '0', 10)
        if (Number.isNaN(currentStart) || currentStart < 0) currentStart = 0
        if (currentStart > lastStart) currentStart = lastStart

        let direction = btn.getAttribute('data-page-direction') || 'forward'
        if (direction !== 'forward' && direction !== 'backward') direction = 'forward'

        const nextStart = direction === 'forward'
            ? Math.min(currentStart + step, lastStart)
            : Math.max(currentStart - step, 0)

        hideItems(allItems)
        const pageItems = allItems.slice(nextStart, nextStart + step)
        showItems(pageItems)

        let nextDirection = direction
        if (nextStart >= lastStart) nextDirection = 'backward'
        if (nextStart <= 0) nextDirection = 'forward'

        btn.setAttribute('data-page-start', String(nextStart))
        btn.setAttribute('data-page-direction', nextDirection)
        swatchesList.classList.remove('is-expanded')

        let toggleCount = 0
        let toggleLabel = ''
        if (nextDirection === 'backward') {
            toggleCount = Math.min(step, nextStart)
            toggleLabel = `-${toggleCount}`
            btn.setAttribute('data-expanded', 'true')
            btn.classList.add('is-expanded')
        } else {
            toggleCount = Math.max(0, totalCount - (nextStart + step))
            toggleLabel = `+${toggleCount}`
            btn.setAttribute('data-expanded', 'false')
            btn.classList.remove('is-expanded')
        }

        btn.textContent = toggleLabel
        btn.setAttribute('aria-label', toggleLabel)
    } else {
        const expanded = btn.getAttribute('data-expanded') === 'true'
        const moreCount = String(totalMoreCount)
        if (!expanded) {
            showItems(baseItems)
            showItems(extraItems)
            swatchesList.classList.add('is-expanded')
            btn.textContent = `-${moreCount}`
            btn.setAttribute('aria-label', `-${moreCount}`)
            btn.setAttribute('data-expanded', 'true')
            btn.classList.add('is-expanded')
        } else {
            showItems(baseItems)
            hideItems(extraItems)
            swatchesList.classList.remove('is-expanded')
            btn.textContent = `+${moreCount}`
            btn.setAttribute('aria-label', `+${moreCount}`)
            btn.setAttribute('data-expanded', 'false')
            btn.classList.remove('is-expanded')
        }
    }

    if (toggleItem) {
        toggleItem.hidden = false
        toggleItem.style.display = ''
    }
}

window.l4vInitProductItemSwatches = () => {
    document.querySelectorAll('.color-swatches').forEach((swatchesList) => {
        const baseItems = [...swatchesList.querySelectorAll('.swatch-item--base')]
        const extraItems = [...swatchesList.querySelectorAll('.swatch-item--extra')]
        const btn = swatchesList.querySelector('.swatch-item--toggle .btn-view-more')
        const toggleItem = swatchesList.querySelector('.swatch-item--toggle')
        if (!btn || !toggleItem) return

        const useSteppedPaging = window.l4vShouldUseSteppedSwatches(swatchesList)
        const allItems = [...swatchesList.querySelectorAll(':scope > li:not(.swatch-item--toggle)')]
        const step = 4

        if (useSteppedPaging) {
            const totalCount = allItems.length
            const moreCount = Math.max(0, totalCount - step)
            allItems.forEach((elem, index) => {
                if (index < step) {
                    elem.hidden = false
                    elem.style.display = ''
                } else {
                    elem.hidden = true
                    elem.style.display = 'none'
                }
            })
            btn.textContent = `+${moreCount}`
            btn.setAttribute('data-more-count', String(moreCount))
            btn.setAttribute('data-expanded', 'false')
            btn.setAttribute('data-page-start', '0')
            btn.setAttribute('data-page-direction', 'forward')
            btn.setAttribute('aria-label', `+${moreCount}`)
            btn.classList.remove('is-expanded')
        } else {
            const moreCount = extraItems.length
            extraItems.forEach((elem) => {
                elem.hidden = true
                elem.style.display = 'none'
            })
            baseItems.forEach((elem) => {
                elem.hidden = false
                elem.style.display = ''
            })
            btn.textContent = `+${moreCount}`
            btn.setAttribute('data-more-count', String(moreCount))
            btn.setAttribute('data-expanded', 'false')
            btn.setAttribute('aria-label', `+${moreCount}`)
            btn.classList.remove('is-expanded')
        }

        toggleItem.hidden = false
        toggleItem.style.display = ''
    })
}

document.addEventListener('DOMContentLoaded', window.l4vInitProductItemSwatches)
window.addEventListener('load', window.l4vInitProductItemSwatches)
window.addEventListener('updated.ecomify.collection', window.l4vInitProductItemSwatches)
document.addEventListener('shopify:section:load', () => setTimeout(window.l4vInitProductItemSwatches, 0))
window.addEventListener('resize', window.debounce ? window.debounce(window.l4vInitProductItemSwatches, 120) : window.l4vInitProductItemSwatches)

// L4V fix43: equalize collection/search card heights per visual row
window.l4vEqualizeProductCardRows = () => {
  const lists = document.querySelectorAll('.collection .product-list, .search .product-list')
  if (!lists.length) return

  lists.forEach((list) => {
    const items = [...list.querySelectorAll(':scope > .product-item')].filter((el) => el.offsetParent !== null)
    if (!items.length) return

    items.forEach((item) => {
      item.style.minHeight = ''
    })

    const rows = []
    items.forEach((item) => {
      const top = Math.round(item.getBoundingClientRect().top)
      const row = rows.find((entry) => Math.abs(entry.top - top) <= 6)
      if (row) row.items.push(item)
      else rows.push({ top, items: [item] })
    })

    rows.forEach((row) => {
      const maxHeight = Math.max(...row.items.map((item) => item.offsetHeight))
      row.items.forEach((item) => {
        item.style.minHeight = `${maxHeight}px`
      })
    })
  })
}

window.addEventListener('load', () => setTimeout(window.l4vEqualizeProductCardRows, 120))
window.addEventListener('resize', window.debounce ? window.debounce(window.l4vEqualizeProductCardRows, 120) : window.l4vEqualizeProductCardRows)
window.addEventListener('updated.ecomify.collection', () => setTimeout(window.l4vEqualizeProductCardRows, 120))

const _l4vOriginalShowAllSwatchesWithinProductItem = window.showAllSwatchesWithinProductItem
window.showAllSwatchesWithinProductItem = (btn, event) => {
  _l4vOriginalShowAllSwatchesWithinProductItem(btn, event)
  setTimeout(window.l4vEqualizeProductCardRows, 60)
}
